<template>
  <div class="chapter-text">
  {{{ content }}}
  </div>
</template>
<style>
  .chapter-text {
    padding:10px;
    background:#333;
    color:#ccc;
    font-family: Verdana,Tahoma,Arial,sans-serif;
  }
</style>
<script language="text/babel">
export default {
  data() {
    return {
      content: 'Loading...',
    };
  },
  route: {
    data({ next }) {
      const url = `/static/archive/${this.$route.params.story}/${this.$route.params.chapter}.chapter`;
      this.$http.get(url)
        .then((res) => { this.content = res.data; next(); });
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** StoryChapter.vue?21d47469
 **/